<p class="component my-1 ps-2">{{'Dashboard'|translate}}</p>

<div class="container-fluid p-2">
  <div class="row w-100 d-flex mx-0 mb-2">
    <div
      class="card dashboard_headers dashboard-header mb-3 cursorPointer"

      (click)="redirectTrackerUrl('UNASSIGNED')"

    >
      <div class="card-body cardalign">
        <span class="count">{{this.totalRecordCount}}</span>
        <span class="card_title1">
          <img
            src="/assets/icons/dash_head.png"
            alt="dash_head"
            class="dash_head"
          />
          <span class="head">{{'Total' | translate}}</span>
        </span>
      </div>
    </div>
    <div
      class="card dashboard_headers dashboard-header1 mb-3 cursorPointer"
      (click)="redirectTrackerUrl('UNASSIGNED')"
    >
      <div class="card-body cardalign">
        <span class="count">{{this.unassignedCount}}</span>
        <span class="card_title1">
          <img
            src="/assets/icons/dash_head.png"
            alt="dash_head"
            class="dash_head1"
          />
          <span class="head">{{'Unassigned'|translate}}</span>
        </span>
      </div>
    </div>
    <div
      class="card dashboard_headers dashboard-header2 mb-3 cursorPointer"
      (click)="redirectTrackerUrl('ASSIGNED')"
    >
      <div class="card-body cardalign">
        <span class="count">{{ this.assignedCount }}</span>
        <span class="card_title1">
          <img
            src="/assets/icons/dash_head.png"
            alt="dash_head"
            class="dash_head2"
          />
          <span class="head">{{'Assigned'|translate}}</span>
        </span>
      </div>
    </div>
    <div
      class="card dashboard_headers dashboard-header3 mb-3 cursorPointer"
      (click)="redirectTrackerUrl('ASSIGNED')"
    >
      <div class="card-body cardalign">
        <span class="count">{{ this.acknowledgedCount }}</span>
        <span class="card_title1">
          <img
            src="/assets/icons/dash_head.png"
            alt="dash_head"
            class="dash_head3"
          />
          <span class="head">{{'Acknowledged'|translate}}</span>
        </span>
      </div>
    </div>
    <div
      class="card dashboard_headers dashboard-header4 mb-3 cursorPointer"
      (click)="redirectTrackerUrl('ASSIGNED')"
    >
      <div class="card-body cardalign">
        <span class="count">{{ this.startedCount }}</span>
        <span class="card_title1">
          <img
            src="/assets/icons/dash_head.png"
            alt="dash_head"
            class="dash_head3"
          />
          <span class="head">{{'Started'|translate}}</span>
        </span>
      </div>
    </div>
    <div
      class="card dashboard_headers dashboard-header5 mb-3 cursorPointer"
      (click)="redirectTrackerUrl('COMPLETED')"
    >
      <div class="card-body cardalign">
        <span class="count">{{ this.completedCount }}</span>
        <span class="card_title1">
          <img
            src="/assets/icons/dash_head.png"
            alt="dash_head"
            class="dash_head4"
          />
          <span class="head">{{'Completed'|translate}}</span>
        </span>
      </div>
    </div>
    <div
      class="card dashboard_headers dashboard-header6 mb-3 cursorPointer"
      (click)="redirectTrackerUrl('UNASSIGNED')"
    >
      <div class="card-body cardalign">
        <span class="count">{{ this.rejectedCount }}</span>
        <span class="card_title1">
          <img
            src="/assets/icons/dash_head.png"
            alt="dash_head"
            class="dash_head5"
          />
          <span class="head">{{'Rejected'|translate}}</span>
        </span>
      </div>
    </div>
    <div
      class="card dashboard_headers  dashboard-header7 mb-3 cursorPointer"
      (click)="redirectTrackerUrl('UNASSIGNED')"
    >
      <div class="card-body cardalign">
        <span class="count">{{ this.failedCount}}</span>
        <span class="card_title1">
          <img
            src="/assets/icons/dash_head.png"
            alt="dash_head"
            class="dash_head6"
          />
          <span class="head">{{'failed'|translate}}</span>
        </span>
      </div>
    </div>
  </div>

  <div class="row m-0 fixheight d-none">
    <!-- CHART 1 -->

    <div class="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-12 p-0">
      <div class="cardshadow mb-3">
        <div class="card_header1">
          <span class="fuelrate">{{'Monthly Money Spent'|translate}}</span>
          <span class="d-flex flex-direction-row">
            <span
              class="material-icons"
              style="color: #b7b7b7; margin-right: 1vh"
            >
            cached
            </span>
            <span class="material-icons d-block"> close </span>
          </span>
        </div>
        <div id="chart1" style="overflow: auto">
          <div id="chart"></div>
        </div>
      </div>
    </div>

    <!-- FLEET IDLE -->

    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-12 paddingMobile">
      <div
        class="card mb-3 cardshadow"
        style="max-width: 100%; justify-content: space-between"
      >
        <div class="card-header">
          <span class="fuelrate pt-2">{{'Fleet Idle'|translate}}</span>
          <div
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <div class="customdropdown">
              <select
                class="form-select form-select"
                aria-label=".form-select-lg example"
                style="height: 4.5vh !important"
              >
                <option selected>Custom</option>
                <option value="1">demo</option>
                <option value="2">demo</option>
                <option value="3">demo</option>
              </select>
            </div>
            <span class="material-icons pt-1" style="color: #b7b7b7">
              cached
            </span>
            <span class="material-icons d-block pt-1"> close </span>
          </div>
        </div>
        <div>
          <div class="row m-0">
            <div
              class="col-6 danger_col"
              style="border-right: 2px solid #324151"
            >
              <span>{{'Total Fleet Idle'|translate}}</span>
              <img src="/assets/icons/danger.png" alt="danger" />
              <span>33 Hrs</span>
            </div>
            <div class="col-6 danger_col">
              <span>{{'Approx Fuel Waste'|translate}}</span>
              <img src="/assets/icons/pump.png" alt="danger" />
              <span>petrol: 62 Ltr</span>
            </div>
          </div>
        </div>

        <div class="note">
          <span style="color: #f84a67">{{'Note'|translate}}:</span> Lorem ipsum dolor sit amet,
          consectetur adipiscing elit. Pretium placerat ac malesuada scelerisque
          semper. Libero a neque lobortis facilisi vel eget eleifend.
        </div>
      </div>
    </div>

    <!-- SHORTCUT -->

    <div class="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-12 p-0">
      <div class="card cardshadow">
        <div class="card_header1">
          <span class="fuelrate">{{'Shortcut'|translate}}</span>
          <span>
            <span class="material-icons d-block"> close </span>
          </span>
        </div>
        <div class="card-body">
          <ul class="list-group list-group-flush">
            <li class="list-group-item">
              <span>{{'Add New Machine'|translate}}</span>
              <img src="/assets/icons/play.png" alt="play" />
            </li>
            <li class="list-group-item">
              <span>{{'Machine List'|translate}}</span>
              <img src="/assets/icons/play.png" alt="play" />
            </li>
            <li class="list-group-item">
              <span>{{'Order List'|translate}}</span>
              <img src="/assets/icons/play.png" alt="play" />
            </li>
            <li class="list-group-item">
              <span>{{'Add New Leads'|translate}}</span>
              <img src="/assets/icons/play.png" alt="play" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="row m-0 w-100 expenserow">
    <!-- CHART 2 -->
    <!-- <div class="row mb-1 m-0 p-0">
      <div class="col-12">
        <app-search-device class="w-100"></app-search-device>
      </div>
    </div> -->
    <div class="flowchart">
      <div class="card_header1">
        <span class="fuelrate">{{'Last 7 Days Tasks'|translate}}</span>
        <span class="d-flex flex-direction-row" style="width: 10vh">
          <span
            class="material-icons"
            style="color: #b7b7b7; margin-right: 1vh"
          >
            cached
          </span>
          <span class="material-icons d-block"> close </span>
        </span>
      </div>
      <div id="chart2"></div>
    </div>
    <div class="flowchart">
      <div class="card_header1">
        <span class="fuelrate">{{'Top 10 Drivers'|translate}}</span>
        <span class="d-flex flex-direction-row" style="width: 10vh">
          <span
            class="material-icons"
            style="color: #b7b7b7; margin-right: 1vh"
          >
            cached
          </span>
          <span class="material-icons d-block"> close </span>
        </span>
      </div>
      <div id="chartOdometer"></div>
    </div>
    <!-- FUEL RATE -->

    <div class="fuel_rate_section">
      <!-- Past 7 DAYS -->

      <div class="card">
        <div class="card_header1">
          <span class="fuelrate">{{'Driver Status'|translate}}</span>
          <span class="d-flex flex-direction-row">
            <span
              class="material-icons"
              style="color: #b7b7b7; margin-right: 1vh"
            >
              cached
            </span>
            <span class="material-icons d-block"> close </span>
          </span>
        </div>
        <div class="fuel_pump">
          <div class="owl-carousel" id="eventCarousel">
            <div class="item d-flex align-items-center justify-content-center flex-column" *ngFor="let e of eventStatusCount">
              <div class="event__count">{{e.recordCount}}</div>
              <div class="font-size-12">{{e.status}}</div>
            </div>
          </div>         
        </div>
      </div>

      <!-- TODAY'S FUEL RATE -->

      <div class="card" style="margin-top: 3vh">
        <div class="card_header1">
          <span class="fuelrate">{{"Today's Fuel Rate"|translate}}</span>
          <span class="d-flex flex-direction-row">
            <span
              class="material-icons"
              style="color: #b7b7b7; margin-right: 1vh"
            >
              cached
            </span>
            <span class="material-icons d-block"> close </span>
          </span>
        </div>

        <div class="state_dropdown">
          <select
            class="form-select scroller mb-3"
            [(ngModel)]="state"
            name="state"
            (change)="getFuelPrice_state()"
            aria-label=".form-select-lg example"
          >
            <option value="" disabled>{{'State'|translate}}</option>
            <option
              value="{{ state }}"
              *ngFor="let state of states; let i = index"
            >
              {{ state }}
            </option>
          </select>
        </div>

        <div class="row m-0 pb-3">
          <div class="col-6 colfirst" style="border-right: 2px solid #324151">
            <span class="fleettext">{{'Diesel'|translate}}</span>
            <img src="/assets/icons/petrol_can.png" alt="danger" />
            <span class="currency1">{{'INR'|translate}} {{ dieselPrice }}</span>
          </div>
          <div class="col-6 colfirst">
            <span class="fleettext"> {{'Petrol'|translate}}</span>
            <img src="/assets/icons/pumpbox.png" alt="danger" />
            <span class="currency1">{{'INR'|translate}} {{ petrolPrice }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
